/* unplugin-vue-components disabled */import { ElDatePicker as __unplugin_components_0 } from 'element-plus/es';import 'element-plus/es/components/date-picker/style/css';
import _regeneratorRuntime from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, isRef as _isRef, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-fdae2be8"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "task-history"
};
var _hoisted_2 = {
  class: "device-info-top"
};
var _hoisted_3 = {
  class: "top-date-picker"
};
var _hoisted_4 = {
  class: "task-history-info"
};
var _hoisted_5 = {
  class: "task-history-info-title"
};
var _hoisted_6 = {
  class: "task-history-info-content"
};
var _hoisted_7 = {
  class: "van-collapse-content"
};
var _hoisted_8 = {
  class: "content-item"
};
var _hoisted_9 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "content-item-label"
  }, "计划类型：", -1);
});
var _hoisted_10 = {
  class: "content-item-label"
};
var _hoisted_11 = {
  class: "content-item"
};
var _hoisted_12 = {
  class: "content-item-label"
};
var _hoisted_13 = {
  class: "content-item-value"
};
var _hoisted_14 = {
  class: "content-item"
};
var _hoisted_15 = {
  class: "content-item-label"
};
var _hoisted_16 = {
  class: "content-item-value"
};
var _hoisted_17 = {
  key: 0
};
var _hoisted_18 = {
  key: 1
};
var _hoisted_19 = {
  class: "content-item"
};
var _hoisted_20 = {
  class: "content-item-label"
};
var _hoisted_21 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", null, "图片：", -1);
});
var _hoisted_22 = {
  key: 0
};
var _hoisted_23 = {
  key: 0,
  class: "content-item-value van-image-list"
};
import './common.less';
import './history.less';
import { showToast } from 'vant';
import { getDeviceHistory } from '@/service/deviceInfo/index';
// interface ParamsType {
//   deviceName?: string;
//   deviceTypeCode?: string;
//   status?: string;
// }
var __default__ = {
  name: 'DeviceInfoDetail'
};
export default /*#__PURE__*/_defineComponent(_objectSpread(_objectSpread({}, __default__), {}, {
  setup: function setup(__props) {
    var route = useRoute();
    var id = route.query.id;
    var listloading = ref(false);
    var finished = ref(false);
    var startTime = ref('');
    var endTime = ref('');
    var imagePreShow = ref(false);
    var imgUrl = ref([]);
    var startPosition = ref(0);
    var historyList = ref([]);
    var imgClick = function imgClick(index) {
      startPosition.value = index;
      imagePreShow.value = true;
    };
    var onLoad = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function onLoad() {
        return _ref.apply(this, arguments);
      };
    }();
    var changeTime = function changeTime(type) {
      if (startTime.value && endTime.value && type == 'start' && startTime.value.getTime() > endTime.value.getTime()) {
        showToast.fail('开始时间不能大于开始时间');
        startTime.value = '';
        return false;
      }
      if (startTime.value && endTime.value && type == 'end' && startTime.value.getTime() > endTime.value.getTime()) {
        showToast.fail('结束时间不能小于开始时间');
        endTime.value = '';
        return false;
      }
      if (startTime.value && endTime.value || !startTime.value && !endTime.value) {
        getList();
      }
    };
    var getList = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var _historyRes$data, historyRes, list, imgUrlList, imgUrlList_2;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return getDeviceHistory({
                pageIndex: 1,
                pageSize: 9999999,
                t: {
                  deviceId: Number(id),
                  beginTime: startTime.value ? "".concat(dayjs(startTime.value).format('YYYY-MM-DD'), " 00:00:00") : undefined,
                  endTime: endTime.value ? "".concat(dayjs(endTime.value).format('YYYY-MM-DD'), " 23:59:59") : undefined
                }
              });
            case 3:
              historyRes = _context2.sent;
              //
              list = (historyRes === null || historyRes === void 0 || (_historyRes$data = historyRes.data) === null || _historyRes$data === void 0 ? void 0 : _historyRes$data.records) || [];
              imgUrlList = list.map(function (item) {
                return (item === null || item === void 0 ? void 0 : item.inspectionHistoryAttachmentList) || [];
              });
              imgUrlList_2 = [];
              imgUrlList_2 = imgUrlList.map(function (item) {
                var urls = [];
                (item === null || item === void 0 ? void 0 : item.length) && item.forEach(function (element) {
                  urls.push((element === null || element === void 0 ? void 0 : element.attachmentUrl) || '');
                });
                return urls;
              });
              imgUrl.value = imgUrlList_2;
              historyList.value = list;
              finished.value = true;
              _context2.next = 17;
              break;
            case 13:
              _context2.prev = 13;
              _context2.t0 = _context2["catch"](0);
              console.log(_context2.t0);
              finished.value = true;
            case 17:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[0, 13]]);
      }));
      return function getList() {
        return _ref2.apply(this, arguments);
      };
    }();
    onMounted( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            getList();
          case 1:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    })));
    return function (_ctx, _cache) {
      var _component_el_date_picker = __unplugin_components_0;
      var _component_van_image_preview = _resolveComponent("van-image-preview");
      var _component_van_image = _resolveComponent("van-image");
      var _component_van_step = _resolveComponent("van-step");
      var _component_van_steps = _resolveComponent("van-steps");
      var _component_van_empty = _resolveComponent("van-empty");
      var _component_van_list = _resolveComponent("van-list");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_el_date_picker, {
        modelValue: _unref(startTime),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
          return _isRef(startTime) ? startTime.value = $event : null;
        }),
        type: "date",
        placeholder: "请选择开始时间",
        size: "small",
        onChange: _cache[1] || (_cache[1] = function ($event) {
          return changeTime('start');
        })
      }, null, 8, ["modelValue"]), _createVNode(_component_el_date_picker, {
        modelValue: _unref(endTime),
        "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) {
          return _isRef(endTime) ? endTime.value = $event : null;
        }),
        type: "date",
        placeholder: "请选择结束时间",
        size: "small",
        onChange: _cache[3] || (_cache[3] = function ($event) {
          return changeTime('end');
        })
      }, null, 8, ["modelValue"])])]), _createVNode(_component_van_list, {
        loading: _unref(listloading),
        "onUpdate:loading": _cache[5] || (_cache[5] = function ($event) {
          return _isRef(listloading) ? listloading.value = $event : null;
        }),
        finished: _unref(finished),
        onLoad: onLoad
      }, {
        default: _withCtx(function () {
          return [_withDirectives(_createElementVNode("div", _hoisted_4, [_createVNode(_component_van_steps, {
            direction: "vertical",
            "inactive-color": "#4C91FD",
            "active-icon": "circle"
          }, {
            default: _withCtx(function () {
              return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(historyList), function (item, index) {
                return _openBlock(), _createBlock(_component_van_step, {
                  key: index
                }, {
                  default: _withCtx(function () {
                    return [_createElementVNode("div", _hoisted_5, [_createElementVNode("span", null, _toDisplayString(item.inspectionUserName), 1), _createElementVNode("span", null, _toDisplayString(item.createTime), 1)]), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_hoisted_9, _createElementVNode("div", _hoisted_10, _toDisplayString(item.taskType), 1)]), _createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, _toDisplayString(item.taskType) + "内容： ", 1), _createElementVNode("div", _hoisted_13, _toDisplayString(item.inspectionItemInfo || '--'), 1)]), _createElementVNode("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, _toDisplayString(item.taskType) + "情况： ", 1), _createElementVNode("div", _hoisted_16, [item.taskType == '保养' ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(item.inspectionContent || '--'), 1)) : _createCommentVNode("", true), item.taskType == '巡检' ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(item.inspectionResultDesc || '--'), 1)) : _createCommentVNode("", true)])]), _createElementVNode("div", null, [_createElementVNode("div", _hoisted_19, [_createElementVNode("div", _hoisted_20, [_hoisted_21, _unref(imgUrl)[index].length == 0 ? (_openBlock(), _createElementBlock("span", _hoisted_22, "--")) : _createCommentVNode("", true)])]), _unref(imgUrl)[index].length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_23, [_createVNode(_component_van_image_preview, {
                      show: _unref(imagePreShow),
                      "onUpdate:show": _cache[4] || (_cache[4] = function ($event) {
                        return _isRef(imagePreShow) ? imagePreShow.value = $event : null;
                      }),
                      images: _unref(imgUrl)[index],
                      "start-position": _unref(startPosition)
                    }, null, 8, ["show", "images", "start-position"]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(imgUrl)[index], function (url, urlIndex) {
                      return _openBlock(), _createBlock(_component_van_image, {
                        key: urlIndex,
                        fit: "cover",
                        position: "left",
                        src: url,
                        onClick: function onClick() {
                          return imgClick(urlIndex);
                        }
                      }, null, 8, ["src", "onClick"]);
                    }), 128))])) : _createCommentVNode("", true)])])])];
                  }),
                  _: 2
                }, 1024);
              }), 128))];
            }),
            _: 1
          })], 512), [[_vShow, _unref(historyList).length]]), !_unref(historyList).length ? (_openBlock(), _createBlock(_component_van_empty, {
            key: 0,
            description: "暂无历史"
          })) : _createCommentVNode("", true)];
        }),
        _: 1
      }, 8, ["loading", "finished"])]);
    };
  }
}));